// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15vcu","largestCol":"styles_largestCol__1aMGH","smallestCol":"styles_smallestCol__2QEdx"};